import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {Data} from '@angular/router';

export interface ViewData extends Data {
    title?: string;
}

export interface CurrentView<D extends ViewData> {
    viewData: Observable<D>;
}

export const CURRENT_VIEW_TOKEN = new InjectionToken<CurrentView<unknown>>('current.view');
